import getStore from './store';

export function getOWAConnectedAccounts() {
    return [...getStore().accountsMap.values()];
}

export function getOWAConnectedAccountStoreState() {
    return getStore().isAccountsStoreInitialized;
}

export function getOWAConnectedAccount(primarySmtpAddress: string) {
    return getStore().accountsMap.get(primarySmtpAddress);
}
